<template>
	<input type="text"
		@focus="onFocus"
		@blur="onBlur"
		@keydown="onKeyDown"
		@input="onInput" />
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Inputmask from 'inputmask'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	name: 'manualDateComponent',

	//=========================================================================
	props: ['value'],

	//=========================================================================
	data() {
		return {
			Value: null
		}
	},

	//=========================================================================
	created() {
		this.Init(this.value)
	},

	//=========================================================================
	mounted() {
		this.$el.value = this.Value
		Inputmask({
			mask: '99.99.9999',
			placeholder: '_',
			showMaskOnHover: false,
			undoOnEscape: false
		}).mask(this.$el)
	},

	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		Init(value) {
			let _val = null
			if (typeof value === 'object' && value instanceof Date && 'getMonth' in value)
				_val = this.formater_Date2StrDate(value)
			else
				_val = String(value)

			if (/^\d{2}.\d{2}.\d{4}/.test(_val))
				this.Value = _val.substr(0, 10)
			else if (/^\d{4}-\d{2}-\d{2}/.test(_val))
			{
				this.Value = _val.substr(8, 2) + '.' + _val.substr(5, 2) + '.' + _val.substr(0, 4)
			}
		},

		//---------------------------------------------------------------------
		onFocus() {
			this.$emit('focus')
		},

		//---------------------------------------------------------------------
		onBlur() {
			let _val = this.makeValue(this.Value)
			if (_val === 'not-date') this.$emit('error', 'person/error_date')
			this.$emit('blur')
		},

		//---------------------------------------------------------------------
		onKeyDown(e) {
			if (e.keyCode === 13 || e.which === 13)
				this.$emit('keydownEnter')
		},

		//---------------------------------------------------------------------
		onInput(event) {
			this.Value = event && event.target && 'value' in event.target ? event.target.value : null
			this.$emit('error', '')
			this.$emit('input', this.makeValue(this.Value))
		},

		//---------------------------------------------------------------------
		// функция: валидирует введенные данные
		//---------------------------------------------------------------------
		validateValue(Value) {
			if (!Value) return false

			let _match = Value.match(/^(\d{2}).(\d{2}).(\d{4})$/)
			if (!_match) return false

			let _day = parseInt(_match[1])
			let _month = parseInt(_match[2])
			let _year = parseInt(_match[3])

			if (isNaN(_day) || isNaN(_month) || isNaN(_year)) return false
			if (_day < 1 || _day > 31) return false
			if (_month < 1 || _month > 12) return false

			const _date = new Date(_year, _month - 1, _day)
			return (Boolean(+_date) && _date.getDate() === _day && _date.getMonth() === (_month - 1))
		},

		//---------------------------------------------------------------------
		// функция: форматирует значение c маской в строковое представление даты
		//---------------------------------------------------------------------
		makeValue(MaskedValue) {
			let _result = 'not-date'

			if (MaskedValue)
			{
				let _val = String(MaskedValue).trim().replace(/_/g, '')
				if (this.validateValue(_val))
					_result = _val.substr(6, 4) + '-' + _val.substr(3, 2) + '-' + _val.substr(0, 2) + ' 00:00:00'
				else
					if (!_val) _result = null
			}
			else _result = null

			return _result
		}

		//---------------------------------------------------------------------
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>



// WEBPACK FOOTER //
// date.vue?2bea6efc